import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { FrameworkView } from "./framework-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import "./framework.scss";
export const FrameworkController = (props) => {
	const [results, setResults] = useState([]);
	const [tourComplete, setTourComplete] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/home?param=homedata&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl, true, {});
			setResults(data);
		};
		search();
	}, [tourComplete]);
	return (
		<>
			<Helmet>
				<title>Factory of the Future Framework | SmarterChains</title>
				<meta name="description" content="Factory of the Future Framework" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/learning-center">Resource Center</BreadcrumbsItem>
			<BreadcrumbsItem to="/framework">Factory of the Future Framework</BreadcrumbsItem>
			<FrameworkView homeData={results} onTourComplete={setTourComplete} {...props} />
			
		</>
	);
};
